<template>
	<div id="energyLeftTop">
		<dv-border-box-6>
			<div class="d-flex pt-2 pl-2">
				<div class="d-flex">
					<span class="mt-3 ml-3 title_t">用能概览</span>
				</div>
			</div>
			<div class="d-flex ml-5 pt-3 pb-3">
				<div>
					<el-date-picker v-model="value" type="daterange" align="right" unlink-panels range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
						value-format="yyyy-MM-dd">
					</el-date-picker>
				</div>
				<div>
					<el-button type="primary" size="medium" @click="onSubmit">查询</el-button>
				</div>
			</div>
			<div class="pt-3 pb-3 mt-2" style="text-align: center;font-size: 0.25rem;">
				总用能
				<span class="led">{{ total }}</span>
				度
			</div>
			<div style="width: 100%;" class="d-flex jc-center mt-2">
				<div style="position: relative;">
					<div class="img"></div>
					<div id="energyLeftTopPie" style="width: 3rem; height: 3rem;"></div>
				</div>
				<div class="dnsj">
					<div style="height: 0.5rem;">
						<div class="float-l ml-2" style="width: 0.1rem;height: 0.1rem;background-color: #47E4E5;margin-top: 0.2rem;"></div>
						<div class="float-l ml-2">空调用能</div>
						<div class="float-r" style="color: #47E4E5">{{ energyLeftTopData.air_dnsj }} 度</div>
					</div>
					<div style="height: 0.5rem;">
						<div class="float-l ml-2" style="width: 0.1rem;height: 0.1rem;background-color: #4293F4;margin-top: 0.2rem;"></div>
						<div class="float-l ml-2">水泵用能</div>
						<div class="float-r" style="color: #4293F4">{{ energyLeftTopData.pump_dnsj }} 度</div>
					</div>
					<div style="height: 0.5rem;">
						<div class="float-l ml-2" style="width: 0.1rem;height: 0.1rem;background-color: #BEE5FB;margin-top: 0.2rem;"></div>
						<div class="float-l ml-2">冷却塔用能</div>
						<div class="float-r" style="color: #BEE5FB">{{ energyLeftTopData.cooling_dnsj }} 度</div>
					</div>
				</div>
			</div>
		</dv-border-box-6>
	</div>
</template>

<script>
	export default {
		components: {

		},
		data() {
			return {
				chart: null,
				pickerOptions: {
					shortcuts: [{
						text: '昨日',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24);
							start.setHours(0);
							start.setMinutes(0);
							start.setSeconds(0);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '本月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setDate(1);
							start.setHours(0);
							start.setMinutes(0);
							start.setSeconds(0);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '本年',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setMonth(0);
							start.setDate(1);
							start.setHours(0);
							start.setMinutes(0);
							start.setSeconds(0);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				value: this.getNowTime(),
				total: '',
			};
		},
		props: ['energyLeftTopData'],
		watch: {
			'energyLeftTopData': {
				handler() {
					this.total = (this.energyLeftTopData.air_dnsj + this.energyLeftTopData.pump_dnsj + this
						.energyLeftTopData.cooling_dnsj).toFixed(1);
					console.log(this.total,this.energyLeftTopData)
					this.draw();
				},
				deep: true
			}
		},
		mounted() {
			this.total = (this.energyLeftTopData.air_dnsj + this.energyLeftTopData.pump_dnsj + this.energyLeftTopData
				.cooling_dnsj).toFixed(1);
			this.draw();
		},
		methods: {
			getNowTime() {
				var date = new Date();
				var seperator1 = "-";
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				var strDate = date.getDate() - 1;
				var endDate = date.getDate();
				if (month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				if (endDate >= 0 && endDate <= 9) {
					endDate = "0" + endDate;
				}
				var currentdate = year + seperator1 + month + seperator1 + strDate;
				var enddate = year + seperator1 + month + seperator1 + endDate;
				// console.log(currentdate)
				return [enddate, enddate];
			},
			draw() {
				// 基于准备好的dom，初始化echarts实例
				this.chart = this.$echarts.init(
					document.getElementById("energyLeftTopPie"), 'dark'
				);

				let option = {
					backgroundColor: 'rgb(255,255,255,0)', //背景色
					// tooltip: {
					// 	trigger: 'item',
					// 	formatter: function(params) {
					// 		console.log(params)
					// 	}
					// },
					// legend: {
					// 	orient: 'vertical',
					// 	right: 50,
					// 	top: 'center',
					// },
					series: [{
						name: '',
						type: 'pie',
						radius: ['50%', '70%'],
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: false,
								fontSize: '16',
								fontWeight: 'bold',
								color: '#fff'
							}
						},
						labelLine: {
							show: true
						},
						data: [
							// {
							// 	value: 0,
							// 	name: '总用能           ' + this.total + '度',
							// 	itemStyle: {
							// 		color: '#FFF',
							// 	}
							// },
							{
								value: this.energyLeftTopData.air_dnsj ? this.energyLeftTopData.air_dnsj :
									0,
								name: '空调用能        ' + this.energyLeftTopData.air_dnsj + '度',
								itemStyle: {
									color: '#47E4E5',
									fontSize: '18px'
								}
							},
							{
								value: this.energyLeftTopData.pump_dnsj ? this.energyLeftTopData
									.pump_dnsj : 0,
								name: '水泵用能        ' + this.energyLeftTopData.pump_dnsj + '度',
								itemStyle: {
									color: '#4293F4'
								}
							},
							{
								value: this.energyLeftTopData.cooling_dnsj ? this.energyLeftTopData
									.cooling_dnsj : 0,
								name: '冷却塔用能     ' + this.energyLeftTopData.cooling_dnsj + '度',
								itemStyle: {
									color: '#BEE5FB'
								}
							},
						]
					}]
				};

				this.chart.setOption(option);
			},
			onSubmit() {
				this.$emit('energySurveyFloorEnergy', this.value[0], this.value[1])
			}
		},
	};
</script>

<style lang="scss">
	#energyLeftTop {
		height: 5.8375rem;
		width: 7.75rem;
		
		.dnsj{
			width: 40%;
			padding: 0.8rem 0.2rem;
			line-height: 0.5rem;
			font-size: 0.2rem;
			color: #fff;
		}
		
		.img{
			width: 0.6rem;
			height: 0.68rem;
			background: url('~@/assets/icon/shandian.png') no-repeat;
			background-size: cover;  
			position: absolute;
			left: 50%;
			margin-left: -0.3rem;
			top: 50%;
			margin-top: -0.34rem;
		}

		.el-input__inner {
			background: none;
			border: 0;
			color: #fff;

			.el-range-input {
				background: none;
				border: dimgray solid 1px;
				border-radius: 3px;
				color: #fff;
			}

			.el-range-separator {
				color: #fff;
				margin-right: 8px;
			}
		}

		.led {
			font-family: 'HarmonyOSSans';
			// font-family: 'led regular';
			font-size: 0.375rem;
			color: #54BAB9;
			text-align: center;
		}
	}
</style>
